const getFreeIncludedKeyQuantity = (
	numberOfRemainingFreeKeys: number,
	keyGroupQuantity: number,
) => {
	const freeIncludedQuantity =
		numberOfRemainingFreeKeys >= keyGroupQuantity ? keyGroupQuantity : numberOfRemainingFreeKeys

	return freeIncludedQuantity
}

export default getFreeIncludedKeyQuantity
